import { Link } from 'react-router-dom';
import { Bell, Menu, X } from 'lucide-react';
import KolMyGlassLogo from '../KolMyGlassLogo';

type PortalMobileTopBarProps = {
  menuOpen: boolean;
  onToggleMenu: () => void;
  notificationsTo: string;
  unreadCount: number;
};

/** Fixed mobile header. Secondary portal actions live in the drawer on small screens. */
export function PortalMobileTopBar({
  menuOpen,
  onToggleMenu,
  notificationsTo,
  unreadCount,
}: PortalMobileTopBarProps) {
  const unreadLabel =
    unreadCount > 0 ? `Notifications, ${unreadCount} unread` : 'Notifications';

  return (
    <header className="md:hidden fixed inset-x-0 top-0 z-40 flex h-12 items-center gap-2.5 border-b border-glass bg-glass-1 px-2 backdrop-blur-[28px]">
      <button
        type="button"
        onClick={onToggleMenu}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-glass-text transition-colors hover:bg-glass-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent2/50"
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
      >
        {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>
      <Link
        to="/"
        className="inline-flex max-h-10 min-w-0 shrink items-center overflow-hidden rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent2/50"
      >
        <KolMyGlassLogo variant="nav" />
      </Link>
      <Link
        to={notificationsTo}
        className="relative ml-auto flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-glass-text-2 transition-colors hover:bg-glass-3 hover:text-glass-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent2/50"
        aria-label={unreadLabel}
      >
        <Bell className="h-5 w-5" />
        {unreadCount > 0 && (
          <span className="absolute right-0.5 top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-accent2 px-0.5 text-[0.6rem] font-bold text-white shadow-[0_0_10px_rgb(var(--accent-rgb)/0.6)]">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </Link>
    </header>
  );
}
